export default __webpack_public_path__ + "static/media/IconDesc_Packager.256.a9844656.png";